export default "__VITE_ASSET__Cl$itYdW__"